import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const CareerReports = ({careerData, formats, selectedPeriod}) => {
    const { t } = useTranslation();
    return (
        <div className="reportsContainer">
            {careerData.playerWinLoss && (careerData.playerWinLoss.length ? careerData.playerWinLoss.map((item, index) =>
                <div key={index} className="dateRanges reports">
                    <div>
                        {
                            <span className="timeEntry">
                                {moment(item.date).format(formats.render[selectedPeriod])}
                            </span>
                        }
                    </div>
                    <div>
                        {
                        selectedPeriod !== 'day' &&
                            <span>{t('career.reports.game')}: {item._id}</span>
                        }
                        <span>{t('career.reports.hand')}: {item.hands}</span>
                    </div>
                    <div>
                        <span className={`${item.wl < 0 ? 'negativeRake' : 'positiveRake'}`}>{item.wl}</span>
                    </div>
                </div>) : <div className="emptyReports">
                    <div className="emptyLogo"></div>
                    <div className="emptyText">
                        {t('noDataAvailableInviteFriends')}
                    </div>
                </div>)
            }
        </div>
    )
}

export default CareerReports;